<template>
  <div id="HolterDepositMachineRequestFormOrder">
    <section>
      <div id="container-center">
        <form>
        <h1 style="" class="title has-text-centered printTarget">院内貸出機患者利用申込登録画面</h1>
        <div>
          <b-steps v-model="activeStep" :animated="true" :rounded="true" :has-navigation="false" label-position="bottom">
            <b-step-item step="1" label="基本情報" icon="clipboard-edit-outline">
              <div id="item-contens">
                <div class="request-title">
                  <b-button class="is-primary" style="float:left;" @click.prevent="goback">戻る </b-button>
                  <span style="position:relative; right:65px;">申込み内容を入力してください。</span>
                </div>
                <div class="card-content margin-top">
                  <table>
                    <tr><th>受付番号</th>
                      <td>
                        {{this.targetNumber}}
                        <span v-if="reqParams.depositMachineFlag" class="depo"/><span style="position:relative; top:17px;" v-if="reqParams.maintenanceNotice" class="maintenance"/>
                      </td>
                    </tr>
                    <tr><th>シリアル番号</th>
                      <td>
                        {{this.serial}}
                      </td>
                    </tr>
                    <template v-for="(patient, index) in reqParams.patientsData">
                      <tr :key="index" v-if="index > 0">
                        <td colspan="2">
                          <b-button style="float:right; width:27px; height:27px; border:none;" icon-left="close-box-outline" @click="deletePatient(index)"></b-button>
                        </td>
                      </tr>
                      <tr :key="index"><th>診察券ID（患者ID）<span class="require" /></th><td><input type="text" v-model="patient.patientRegistrationCard" maxlength="50" class="1" :name="'診察券ID（患者ID）'" validate="required" /></td></tr>
                      <tr :key="index"><th>患者名<span class="require" /></th><td><input type="text" style="margin-right: 5px; width: 446px !important;" placeholder="姓" v-model="patient.patientFamilyName" class="1" :name="'患者名(姓)'" validate="required" maxlength="49"/><input type="text" style="width: 446px !important;height:27px !important;" placeholder="名" v-model="patient.patientFirstName" class="1" :name="'患者名(名)'" validate="required" maxlength="49"/></td></tr>
                      <tr :key="index"><th>患者名（カナ）<span class="require" /></th><td><input type="text" style="margin-right: 5px; width: 446px !important;" placeholder="セイ" v-model="patient.patientFamilyNameKana" class="1" :name="'患者名カナ(セイ)'" validate="required|kana" maxlength="49"/><input type="text" style="width: 446px !important;height:27px !important;" placeholder="メイ" v-model="patient.patientFirstNameKana" class="1" :name="'患者名カナ(メイ)'" validate="required|kana" maxlength="49"/></td></tr>
                      <tr :key="index"><th>性別<span class="require" /></th><td>
                        <div class="block 1" validate="radioRequire" :name="'性別'">
                          <b-radio size="is-small" v-model="patient.gender" native-value="-">-</b-radio>
                          <b-radio size="is-small" v-model="patient.gender" native-value="男">男</b-radio>
                          <b-radio size="is-small" v-model="patient.gender" native-value="女">女</b-radio>
                        </div></td>
                      </tr>
                      <tr :key="index"><th>生年月日<span class="require"/></th><td><input type="date" v-model="patient.birthday" :input="inputBirthday(patient.birthday,index)" class="1" :name="'患者の生年月日'" validate="required|date|birthDay" :max="yyyy_hyp_MM_hyp_dd(new Date())" style="width:150px;height:27px;"/><span v-if="patient.birthday" style="margin-left:10px;">{{patient.japaneseCalendar}}</span></td></tr>
                      <tr :key="index"><th>年齢</th><td><input type="text" disabled v-model="patient.age"/></td></tr>
                      <tr :key="index"><th>検査目的<span class="require"/></th>
                        <td>
                          <select v-model="patient.inspectionPurpose" class="1" :name="'検査目的'" validate="required">
                            <option v-for="inspectionPurpose in inspectionPurposeList" :value="inspectionPurpose.value" :key="inspectionPurpose.value">{{ inspectionPurpose.label1 }}</option>
                          </select>
                        </td>
                      </tr>
                      <tr :key="index"><th>ペースメーカー<span class="require"/></th>
                        <td>
                          <select v-model="patient.pacemaker" class="1" :name="'ペースメーカー'" validate="required">
                            <option></option>
                            <option value="1">有り</option>
                            <option value="2">無し</option>
                          </select>
                        </td>
                      </tr>
                      <tr :key="index"><th>基礎疾患・合併症</th><td><input type="text" v-model="patient.underlyingDisease" maxlength="256" :name="'基礎疾患・合併症'"/></td></tr>
                      <tr :key="index"><th>投薬状況</th><td><input type="text" v-model="patient.dosingStatus" maxlength="256" :name="'投薬状況'"/></td></tr>
                      <tr :key="index"><th>主訴</th><td><input type="text" v-model="patient.chiefComplaint" maxlength="256" :name="'主訴'"/></td></tr>
                      <tr :key="index"><th>連絡先（自宅または携帯）<span class="require" /></th><td><input type="text" v-model="patient.phoneNumber" maxlength="20" placeholder="電話をお持ちでない場合は「なし」と記載してください。" class="1" :name="'患者の連絡先（自宅または携帯）'" validate="required"/></td></tr>
                      <tr :key="index"><th></th><td><span style="font-size:12px;">携帯電話(スマートフォン)をお持ちの場合は携帯電話(スマートフォン)の番号をご記入ください。機器が未返却の場合に返却を促すショートメッセージが自動的に送信されます。</span></td></tr>
                      <tr :key="index">　
                        <th>備考、その他、注意事項</th>
                        <td>
                          <textarea v-model="reqParams.patientMemo" maxlength="256" style="resize:vertical;max-width:100%;"></textarea>
                        </td>
                      </tr>
                    </template>
                    <tr><th colspan="2">【ePatch】</th></tr>
                    <tr><th>貸出日<span  class="require" name="item_step1" id="depositMachineRentalDate"/></th>
                      <td>
                        <input type="date" v-model="reqParams.depositMachineRentalDate"  class="depositMachineRentalDate 1"  name="出荷日" validate="required|date" disabled style="width:150px;height:27px;"/>
                      </td>
                    </tr>
                    <tr><th>返却日</th><td>{{reqParams.returnDate}}</td></tr>
                    <tr>
                      <th>備考、その他、注意事項</th>
                      <td>
                        <textarea v-model="reqParams.memo" maxlength="256" style="resize:vertical;max-width:100%;"></textarea>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
              <div id="item-contens">
                <div class="request-title">
                  <span>申込み内容を確認のうえ、「申込みを完了する」ボタンを押下してください。</span>
                </div>
                <b-button class="is-primary" style="margin-top:5px;width:250px;" @click="requestHolter">申込みを完了する</b-button>
              </div>
            </b-step-item>
          </b-steps>
        </div>
        </form>
      </div>
    </section>
  </div>
</template>
<script>
import {role} from "@/components/mock/base/const.js";
import {atLaunchHidden} from "@/components/mock/base/const.js";
import {choicesType} from "@/components/mock/base/const.js";
import {extUserStatus} from "@/components/mock/base/const.js";
import OrganizationSelectModal from "@/components/mock/philips/common/OrganizationSelectModal";
import OfficeCalenderModal from "@/components/mock/guest/OfficeCalenderModal";
import {LendingPeriod} from "@/components/mock/base/const.js";

export default {
  name: "HolterDepositMachineRequestFormOrder",
  methods: {
    requestHolter: function() {
      // バリデーションチェック
      let stepItems = document.getElementsByClassName("step-item")
      let target
      for(let item of stepItems){
        if(item.getAttribute("style") != "display: none;"){
          target = item
        }
      }
      let activeStep = target ? target.getAttribute("step") : ""
      if(activeStep){
        let elements = document.getElementsByClassName(activeStep)
        let result = this.selfMadeValidation(elements)
        if(result.isError){
          this.showErrorMessage(result.msg)
          return;
        }else{
          // 再レンダリングの為、フラグ切替
          //this.renderKey = !this.renderKey
          //this.activeStep += 1;
        }
      }

      let messsage = ""
      messsage += "患者情報を登録するシリアル番号は以下です。<br/>"
      messsage += "　　<font style=\"font-size: 24px;background-color:#F0F0A0\"><b>"+this.serial + "</b></font><br/>";
      messsage += "シリアル番号が正しいことを確認して「OK」ボタンを押してください。"
      this.$dialog.confirm({
        title: "シリアル番号の確認",
        message: messsage,
        cancelText: "修正する",
        onConfirm: async () => {
          this.compleateFlg = false;
          let excuteApi = this.setHolterDepositMachineRequestFormOrderPOST;
          let successCallBack = this.setHolterDepositMachineRequestFormOrderPOSTSuccess;
          let errorCallBack = this.setHolterDepositMachineRequestFormOrderPOSTError;
          // WebAPI Call
          await this.apiCall(excuteApi, successCallBack, errorCallBack)
          this.back();
        }
      });
    },
    back: function () {
      this.$router.push({
        name: "HolterDepositMachineList",
        params: { searchConditions: this.searchParams },
      });
    },
    goback: function() {
      this.back();
    },
    setHolterDepositMachineRequestFormOrderPOST: function(client) {
      this.reqParams.leadWireAdapter = false;
      let obj = JSON.parse(JSON.stringify(this.reqParams));
      //obj.shippingDate = obj.shippingDate ? obj.shippingDate.replace(/-/g, "/") : ""
      obj.clientDate = new Date().toString();
      obj.depositMachineRentalDate = obj.depositMachineRentalDate ? obj.depositMachineRentalDate.replace(/-/g, "/") :""
      obj.returnDate = obj.returnDate ? obj.returnDate.replace(/-/g, "/") :""
      for(const patient of obj.patientsData){
        patient.age = patient.age + ""
        patient.birthday = patient.birthday ? patient.birthday.replace(/-/g, "/") :""
      }
      obj.belongsId = this.belongsId
      obj.shortestShippingDateList = this.getShortestShippingDate();
      return client.apis.externalHolter.setHolterDepositMachineRequestFormOrderPOST({
        body:obj
      });
    },
    setHolterDepositMachineRequestFormOrderPOSTSuccess: function(result) {
      // 成功メッセージ表示
      this.requestDate = result.obj.requestDate
      this.receiptNumber = result.obj.receiptNumber
      this.compleateFlg = true;
    },
    setHolterDepositMachineRequestFormOrderPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    postCodeSearch: function(){
      let excuteApi = this.getAddressFromPostCodePOST;
      let successCallBack = this.getAddressFromPostCodePOSTSuccess;
      let errorCallBack = this.getAddressFromPostCodePOSTError;
      // WebAPI Call
      return this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getAddressFromPostCodePOST: function(client) {
      return client.apis.apiCommon.getAddressFromPostCodePOST({
        body:{
          postCode:this.searchTargetPostCode
        }
      });
    },
    getAddressFromPostCodePOSTSuccess: function(result) {
      this.searchTargetAddress = result.obj
      this.searchTargetPostCode = ""
    },
    getAddressFromPostCodePOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
      this.searchTargetPostCode = ""
    },
    getChoicesList: async function() {
      this.inspectionPurposeList = this.getChoiceList(this.choicesType.holterInspectionPurpose, false);
      this.inspectionPurposeList.unshift({})
    },
    inputBirthday: function(birthday,index){
      let age = this.getAge(birthday)
      if(!isNaN(Number(age))){
        this.reqParams.patientsData[index].age = age < 0 ? 0 : age

        const date = new Date(birthday);
        const options = {era: 'long'};
        this.reqParams.patientsData[index].japaneseCalendar = "【"+this.getJapaneseCalendar(date)+"】"
      }else{
        this.reqParams.patientsData[index].age = ""
      }
    }
  },
  data() {
    const date = new Date();
    const dateDays = date.getFullYear()+"-"+('0' + (date.getMonth() + 1)).slice(-2)+"-"+('0' + date.getDate()).slice(-2);
    let workDate = new Date(date);

    let targetNumber = this.$route.params["receiptNumber"];
    let searchParams = this.$route.params["searchConditions"];
    let serial = this.$route.params["serial"];
    let depositMachineFlag = this.$route.params["depositMachineFlag"];
    let inspectionPeriod = this.$route.params["inspectionPeriod"];
    let maintenanceNotice = this.$route.params["maintenanceNotice"];

    // 検査期間ごとに返却日を計算する
    if (inspectionPeriod == "1") {  //検査期間：24時間
      workDate = this.getBusinessDay(workDate, LendingPeriod.holter_oneday_period);
    } else if (inspectionPeriod == "2") { // 検査期間：5日
      workDate = this.getBusinessDay(workDate, LendingPeriod.holter_fiveday_period);
    } else if (inspectionPeriod == "3") { // 検査期間：10日
      workDate = this.getBusinessDay(workDate, LendingPeriod.holter_tenday_period);
    } else if (inspectionPeriod == "4") { // 検査期間：14日
      workDate = this.getBusinessDay(workDate, LendingPeriod.holter_fourteen_period);
    }

    let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    let roleId = userInfo.roleId;
    let userId = userInfo.id;
    let miniday = new Date()
    let maxDate = new Date()
    maxDate.setDate(maxDate.getDate() + 365);
    let maxday = new Date(maxDate.getFullYear(), maxDate.getMonth(), maxDate.getDate());
    let isHospital = roleId == role.role_hospital;
    let return_data = {
      targetNumber: targetNumber,
      searchParams: searchParams,
      serial: serial,
      atLaunchHidden: atLaunchHidden,
      role: role,
      roleId: roleId,
      userId: userId,
      choicesType:choicesType,
      extUserStatus: extUserStatus,
      belongsId:userInfo.belongsId,
      isChecked: true,
      activeStep: 0,
      miniday: miniday,
      maxday:maxday,
      disabledDays: [],
      inspectionPurposeList: [],
      lendingPeriod:LendingPeriod.period,
      reqParams: {
        receiptNumber: targetNumber,
        serial: serial,
        depositMachineFlag: depositMachineFlag,
        returnDate: this.yyyy_sla_MM_sla_dd(workDate),
        depositMachineRentalDate: dateDays,
        deliverySlip:false,
        memo: "",
        maintenanceNotice: maintenanceNotice,
        patientsData: [{
          patientRegistrationCard:"",
          patientFamilyName:"",
          patientFirstName:"",
          patientFamilyNameKana:"",
          patientFirstNameKana:"",
          gender:"",
          birthday:"",
          age:"",
          japaneseCalendar:"",
          pacemaker:"",
          inspectionPurpose:"",
          underlyingDisease:"",
          dosingStatus:"",
          chiefComplaint:"",
          zip:"",
          address:"",
          address1:"",
          address2:"",
          phoneNumber: "",
          receiverName: "",
          desiredDeliveryTimeZone: "",
          memo: "",
        }]
      },
      compleateFlg:false,
      searchTargetPostCode:"",
      searchTargetAddress:null,
      requestDate:"",
      receiptNumber:"",
      renderKey:true,
      officeCalenderActive: false,
      needAgree: false,
      isHospital
    };

    return return_data;
  },
  computed: {},
  filters: {
    getNameFilter: function(val, list){
      let target = list.find(item => item.value == val)
      if(target){
        return target.label1
      }
      return ""
    }
  },
  components: {
    organizationSelectModal:OrganizationSelectModal,
    officeCalenderModal:OfficeCalenderModal
  },
  async mounted() {
    let _this = this
    await this.getBusinessDayPOST(null, 2, function(result) {
      _this.miniday = new Date(result.obj.date)
    })

    // マスタ取得
    await this.getChoicesList();
  }
};
</script>

<style>
</style>
<style lang="scss" scoped>
.depositMachineRentalDate {
  width: 150px  !important;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/guest/HolterDepositMachineRequestFormOrder.vue